import { ReactElement } from 'react';

import {
   ConfidentialResourceAccessRequestQuery,
   ConfidentialResourceAccessRequestRejectCommand,
   Practitioner,
} from '@dreryk/egabinet-medical-data-confidentiality-frontend-api';

import { Choice } from '@dreryk/watermelon';
import { refetchCqrsQuery, useCqrsCommand } from '@dreryk/command-query-react-common';
import {
   ButtonColorVariant,
   ButtonVariant,
   dispatchSnackbarPositiveEvent,
   ModalConfirmButton,
} from '@dreryk/react-components';
import { createInterpolatedTranslationKey, practitionerNameFormatter } from '@dreryk/react-common';

import { systemActivityTranslationKeys } from '../../../../translations';

import { ReviewRequestFormBean, ReviewRequestFormController } from './form/ReviewRequestForm.types';

type ReviewRequestRejectButtonProps = {
   requestId: number;
   grantee: Practitioner;
   onSuccess: VoidFunction;
   handleSubmit: ReviewRequestFormController['handleSubmit'];
};

export const ReviewRequestRejectButton = (props: ReviewRequestRejectButtonProps): ReactElement => {
   const { executeAsync: rejectRequest } = useCqrsCommand<void, ReviewRequestFormBean>(
      (parameters) => {
         const command = new ConfidentialResourceAccessRequestRejectCommand();
         command.requestId = props.requestId;
         command.decisionJustification = Choice.withUseDefaultIfNull(parameters.decisionJustification);
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(
               createInterpolatedTranslationKey(systemActivityTranslationKeys.rejectSuccess, {
                  practitionerName: practitionerNameFormatter(props.grantee),
               })
            );
            refetchCqrsQuery(ConfidentialResourceAccessRequestQuery);
            props.onSuccess();
         },
      }
   );

   return (
      <ModalConfirmButton
         testId={'rejectAccess'}
         label={systemActivityTranslationKeys.rejectAccess}
         variant={ButtonVariant.SECONDARY}
         colorVariant={ButtonColorVariant.ERROR}
         onClick={props.handleSubmit(rejectRequest)}
      />
   );
};
